module.exports = __webpack_public_path__ + "static/media/default_car.cbb8576a.png";